module.exports = __webpack_public_path__ + "img/1@2x.2450c921.png";